import CanvasRenderer from "./types/canvas-renderer";
export default class KeyboardRenderer extends CanvasRenderer {
    createKeyHandlerDown(data) {
        return undefined;
    }
    createKeyHandlerUp(data) {
        return undefined;
    }
    restart(data, timestamp) {
        super.restart(data, timestamp);
        this.registerListener(data);
    }
    render(data) {
        super.render(data);
        this.registerListener(data);
    }
    registerListener(data) {
        if (!this.onKeyDown) {
            this.onKeyDown = this.createKeyHandlerDown(data);
            if (this.onKeyDown) {
                document.addEventListener("keydown", this.onKeyDown);
            }
        }
        if (!this.onKeyUp) {
            this.onKeyUp = this.createKeyHandlerUp(data);
            if (this.onKeyUp) {
                document.addEventListener("keyup", this.onKeyUp);
            }
        }
    }
    unregisterListener() {
        if (this.onKeyDown) {
            document.removeEventListener("keydown", this.onKeyDown);
            this.onKeyDown = undefined;
        }
        if (this.onKeyUp) {
            document.removeEventListener("keyup", this.onKeyUp);
            this.onKeyUp = undefined;
        }
    }
    stopRendering() {
        super.stopRendering();
        this.unregisterListener();
    }
}
